export default __webpack_public_path__ + "static/media/not_supported_region.8dcf6639.png";